import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './Video.module.css';
import { FaRobot, FaCalendarAlt, FaClock } from 'react-icons/fa';

// Importa los videos
import videoFileDesktop from './images/iphone.mp4';
import videoFileMobile from './images/iphone.mp4'; // Asegúrate de tener esta versión del video

const Seccion1 = () => {
  // Determina si el dispositivo es móvil basado en el ancho de la ventana
  const isMobile = window.innerWidth <= 768;
  const videoSource = isMobile ? videoFileMobile : videoFileDesktop;
  const navigate = useNavigate();

  return (
    <div className={styles.seccion}>
      <div className={styles.content}>
        <h1 className={`${styles.title} ${styles.fadeIn}`}>Tu Asistente AI Personal</h1>
        <p className={`${styles.subtitle} ${styles.typewriter}`}>Eficiencia y productividad a tu alcance con las mejores IAs</p>
        <div className={`${styles.videoWrapper} ${styles.fadeIn}`}>
          <video className={styles.video} loop autoPlay muted playsInline>
            <source src={videoSource} type="video/mp4" />
            Tu navegador no soporta la etiqueta de video.
          </video>
        </div>
        <p className={`${styles.description} ${styles.fadeIn}`}>
          <FaRobot className={styles.icon} /> Asistente AI personalizado<br/>
          <FaCalendarAlt className={styles.icon} /> Gestión de agenda<br/>
          <FaClock className={styles.icon} /> Consultas resueltas 24/7
        </p>
        <button className={`${styles.button} ${styles.pulseButton}`} onClick={() => navigate('/contacto')}>
          Agendar
        </button>
      </div>
    </div>
  );
};

export default Seccion1;